import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import About from './home/About';
import Banner from './home/Banner';
import Projects from './home/Projects';
import Service from './home/Service';
import KeyOfferings from './home/KeyOfferings';
import Clients from './home/Clients';
import Blog from './home/Blog';
import Testimonial from './home/Testimonial';
import FAQ from './home/FAQ';
import KeyMetrics from './home/KeyMetrics';
import IndustriesWeServe from './home/IndustriesWeServe';
//import '../styles/Home.css';

// Add type declarations for owl carousel and jQuery
declare global {
  interface JQuery {
    owlCarousel(options?: any): JQuery;
  }
  interface Window {
    $: any;
    jQuery: any;
  }
}

const Home: React.FC = () => {
  const [showBanner, setShowBanner] = React.useState(false);

  useEffect(() => {
    // Show popup only before 17-Oct-2025
    const today = new Date();
    const cutoff = new Date('2025-10-17T23:59:59');
    if (today <= cutoff) {
      setShowBanner(true);
    }

    // Wait for jQuery to be available
    const initializeCarousels = () => {
      if (typeof window.$ !== 'undefined') {
        // Header carousel
        window.$(".header-carousel").owlCarousel({
          animateOut: 'fadeOut',
          items: 1,
          margin: 0,
          stagePadding: 0,
          autoplay: true,
          smartSpeed: 1000,
          dots: false,
          loop: true,
          nav: true,
          navText: [
            '<i class="bi bi-arrow-left"></i>',
            '<i class="bi bi-arrow-right"></i>'
          ],
        });

        // Service-carousel
        window.$(".service-carousel").owlCarousel({
          autoplay: true,
          smartSpeed: 2000,
          center: false,
          dots: false,
          loop: true,
          margin: 25,
          nav : true,
          navText : [
              '<i class="bi bi-arrow-left"></i>',
              '<i class="bi bi-arrow-right"></i>'
          ],
          responsiveClass: true,
          responsive: {
              0:{
                  items:1
              },
              576:{
                  items:1
              },
              768:{
                  items:2
              },
              992:{
                  items:2
              },
              1200:{
                  items:2
              }
          }
        });

        // testimonial carousel
        window.$(".testimonial-carousel").owlCarousel({
            autoplay: true,
            smartSpeed: 1500,
            center: false,
            dots: true,
            loop: true,
            margin: 25,
            nav : false,
            navText : [
                '<i class="fa fa-angle-right"></i>',
                '<i class="fa fa-angle-left"></i>'
            ],
            responsiveClass: true,
            responsive: {
                0:{
                    items:1
                },
                576:{
                    items:1
                },
                768:{
                    items:1
                },
                992:{
                    items:1
                },
                1200:{
                    items:2
                }
            }
        });
      }
    };

    // Initialize carousels when component mounts
    initializeCarousels();
  }, []);
  return (
    <>
      {/* Popup Modal for IFAT Banner */}
      {showBanner && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }} tabIndex={-1} role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ borderRadius: '10px', overflow: 'hidden' }}>
              <div className="modal-header" style={{ borderBottom: 'none' }}>
                <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowBanner(false)}></button>
              </div>
              <div className="modal-body p-0">
                <img src="/img/ifat_banner.jpg" alt="IFAT Banner" style={{ width: '100%', height: 'auto', display: 'block' }} />
              </div>
            </div>
          </div>
        </div>
      )}
      {/* ...existing code... */}
      <div className="header-carousel owl-carousel overflow-hidden">
        <div className="header-carousel-item hero-section">
          <div className="hero-bg-half-1"></div>
          <div className="hero-shape-1"></div>
          <div className="carousel-caption">
            <div className="container">
              <div className="row g-4 align-items-center">
                <div className="col-lg-8 animated fadeInLeft">
                  <div className="text-sm-center text-md-start">
                    <h1 className="display-3 text-white mb-4">Advanced Water Treatment Solutions for Industrial
                      & Municipal Applications</h1>
                    <div className="d-flex justify-content-center justify-content-md-start flex-shrink-0 mb-4">
                      <Link className="btn btn-primary py-3 px-4 px-md-5 ms-2" to="/about">Learn More</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="header-carousel-item hero-section">
          <div className="hero-bg-half-2"></div>
          <div className="hero-shape-2"></div>
          <div className="carousel-caption">
            <div className="container">
              <div className="row g-4 align-items-center">
                <div className="col-lg-8 animated fadeInLeft">
                  <div className="text-sm-center text-md-start">
                    <h1 className="display-3 text-white mb-4">Advanced Water Treatment Solutions for Industrial
                      & Municipal Applications</h1>
                    <div className="d-flex justify-content-center justify-content-md-start flex-shrink-0 mb-4">
                      <Link className="btn btn-primary py-3 px-4 px-md-5 ms-2" to="/about">Learn More</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <About />
      <Banner />
      <Projects />
      <IndustriesWeServe />
      <Service />
      <KeyMetrics />
      <KeyOfferings />
      <Clients />
      <Blog />
      <Testimonial />
      <FAQ />
    </>
  );
};

export default Home;
